import config from '../config.js';

export default {
    searchGoalEntries(params) {
        let path = process.env.apiPath + '/advertiser/goalEntries.search';
        params = params || {};
        params.fields = 'goal_entry.creative_types,goal_entry.conversion_cap,goal_entry.offer,goal_entry.goal,offer.advertiser,offer.locales,offer.default_link,goal.offer,offer.image,goal.description,goal.traffic_restrictions,goal_entry.status';
        return this.makeRequest(path, params);
    },

    searchOffers(params) {
        let path = process.env.apiPath + '/advertiser/offers.search';
        params = params || {};
        params.fields = 'offer.advertiser,offer.description,offer.default_link,offer.locales,link.url,link.selfie_link,offer.image,offer.tds_domain';
        return this.makeRequest(path, params);
    },

    searchGoalActions(params) {
        let path = process.env.apiPath + '/advertiser/goalActions.search';
        params = params || {};
        params.fields = params.fields || 'goal_action.goal,goal_action.commission_contract,goal.offer,action.offer';
        return this.makeRequest(path, params);
    },

    searchAccountEntries(params) {
        let path = process.env.apiPath + '/advertiser/publisherAccountEntries.search';
        params = params || {};
        params.fields = 'publisher_account_entry.currency_ratio,publisher_account_entry_source.parameters,currency_ratio.rates';
        return this.makeRequest(path, params);
    },
}
